module.exports = __webpack_public_path__ + "img/traxe_ctv.4038a1de.png";